const Categories = () => <h1 className="title">In construction</h1>;

export default Categories;
